import styled from "styled-components";

export const OpeningHoursDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 18px;
  max-width: 500px;
`;
